<div [formGroup]="filterForm" class="filter-bar-container">
  <div class="row">
    <div *ngFor="let filter of filters" [class]="filter.col || 'col-md-3'">
      <!-- Select -->
      <div *ngIf="filter.type === 'select'">
        <z-select
          [label]="filter.label"
          [items]="(getOptionsObservable(filter) | async) || []"
          [formControlRef]="$any(filterForm.get(filter.key))"
          [id]="filter.key"
        ></z-select>
      </div>

      <!-- Input -->
      <div *ngIf="filter.type === 'input'">
        <z-input
          [label]="filter.label"
          [placeholder]="filter.placeholder || ''"
          [formControlRef]="$any(filterForm.get(filter.key))"
          [id]="filter.key"
        ></z-input>
      </div>
    </div>
  </div>
</div>
